// extracted by mini-css-extract-plugin
export default {"cta":"LF-z","disabled":"MF-z"};